import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Checkbox, FormControlLabel, List, ListItem, Modal, Popover, TextField } from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { baseURL } from "../../Constant";
import "./ViewSignature.css";
import axios from "axios";
import DateRangePicker from "../DateRangePicker";
import { styled } from "@mui/material/styles";
const CustomFooter = () => <div></div>;
const ColorButton = styled(Button)(({
  theme
}) => ({
  color: theme.palette.getContrastText("#7500C0"),
  backgroundColor: "#7500C0",
  "&:hover": {
    backgroundColor: "#7500C0",
    color: "#fff"
  }
}));
const ViewSignature = () => {
  const [feedbackData, setFeedbackData] = useState([]);
  const [filteredFeedbackData, setFilteredFeedbackData] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentColumn, setCurrentColumn] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [defaultToDate, setDefaultToDate] = useState(new Date());
  const [sortModel, setSortModel] = useState([{
    field: "created_at",
    sort: "desc"
  }]);
  const [openModal, setOpenModal] = useState(false);
  const [modalRecord, setModalRecord] = useState();
  const handleOpen = record => {
    setOpenModal(true);
    setModalRecord(record);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  async function getFeedbackData() {
    try {
      const response = await axios.get(`${baseURL}/pptx/signatures`
      // "http://localhost:3032/fetchFeedback"
      );
      setFeedbackData(response.data.data);
    } catch (e) {
      console.log("error in fetching feedback");
    }
  }
  useEffect(() => {
    getFeedbackData();
  }, []);
  useEffect(() => {
    const sortedArray = feedbackData?.sort((a, b) => {
      return new Date(b.date) - new Date(a.date); // Ensure to compare correctly
    });
    setFilteredFeedbackData(feedbackData);
  }, [feedbackData]);
  const isDateInRange = (dateToCheck, startDate, endDate) => {
    const startOfDayToCheck = new Date(dateToCheck.setHours(0, 0, 0, 0));
    const startOfDayStart = new Date(startDate.setHours(0, 0, 0, 0));
    let startOfDayEnd;
    startOfDayEnd = new Date(endDate.setHours(0, 0, 0, 0));
    return startOfDayToCheck >= startOfDayStart && startOfDayToCheck <= startOfDayEnd;
  };
  useEffect(() => {
    let formedToDate = toDate == null ? defaultToDate : toDate;
    setFilteredFeedbackData(feedbackData?.filter(item => isDateInRange(new Date(item.created_at), new Date(fromDate), new Date(formedToDate))));
  }, [fromDate, toDate]);
  function formatDate(string) {
    var options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric"
    };
    return new Date(string).toLocaleDateString([], options);
  }
  const columns = [{
    field: "id",
    flex: 0.2,
    headerName: <div>SI#</div>,
    renderCell: params => params.api.getSortedRowIds().indexOf(params.id) + 1,
    sortable: false
  }, {
    field: "enterprise_id",
    flex: 0.7,
    sortable: false,
    headerName: <div>Enterprise Id</div>
  }, {
    field: "designation",
    flex: 0.7,
    sortable: false,
    headerName: <div>Designation</div>
  }, {
    field: "original_filename",
    flex: 0.7,
    sortable: false,
    headerName: <div>File Name</div>
  }, {
    field: "uploaded_by",
    flex: 0.7,
    sortable: false,
    headerName: <div>Uploaded By</div>
  }, {
    field: "uploaded_at",
    headerName: <div>Uploaded Date <br /> <span className="migrated-style-viewsignature-cd3686-1">(mm/dd/yyyy)</span></div>,
    minWidth: 50,
    sortable: true,
    flex: 0.7,
    renderCell: params => <div>{formatDate(params.row.uploaded_at)}</div>
  }];
  let dataGridStyle = {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#022278",
      color: "white"
    },
    "& .MuiDataGrid-root": {
      width: "100%"
    },
    "& .MuiDataGrid-sortIcon": {
      color: "#fff"
    },
    "& .MuiDataGrid-columnHeader": {
      position: "sticky",
      top: 0,
      backgroundColor: "#022278",
      color: "#fff"
    },
    "& .MuiDataGrid-columnHeaders": {
      width: "var(--DataGrid-rowWidth)"
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "white",
      width: "calc(100% - 2px)"
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      "justify-content": "left"
    }
  };
  const clearFilters = () => {
    setFromDate(null);
    setToDate(null);
  };
  let rowsWithSerial = filteredFeedbackData.map((row, index) => ({
    ...row,
    id: index + 1
  }));
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return <>      
      <DataGrid rows={rowsWithSerial} columns={columns} initialState={{
      pagination: {
        paginationModel: {
          page: 0,
          pageSize: 7
        }
      }
    }} sortModel={sortModel} onSortModelChange={newModel => setSortModel(newModel)} rowsPerPageOptions={[]} disableColumnMenu // This removes the three dots menu
    sx={dataGridStyle} components={{
      Footer: CustomFooter // Replace default footer with your custom component
    }} />
      <Modal open={openModal} onClose={handleClose} aria-labelledby="child-modal-title" closeAfterTransition aria-describedby="child-modal-description" className="modal-container">
        <Box className="model">
          <div className="model_heading">
            <h5 className="paramodel">Details</h5>
            <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
            Close
            </span>
          </div>
          <hr />
          <div className="program-modal-details">
            <div className="program-details-wrap">
              <p className="program-details-header">Enterprise ID: </p>
              <p>{modalRecord?.enterpriseID}</p>
            </div>
            <div className="program-details-wrap">
              <p className="program-details-header">Category: </p>
              <p>{modalRecord?.subcategory}</p>
            </div>
            <div className="program-details-wrap">
              <p className="program-details-header">Sub Category: </p>              
              <p>{modalRecord?.mailtype}</p>
            </div>            
            <div className="program-details-wrap">
              <p className="program-details-header">Program Name: </p>
              <p>{modalRecord?.programname}</p>
            </div>
            <div className="program-details-wrap">
              <p className="program-details-header">Rating: </p>
              <p className="program-details-value">{modalRecord?.overallRating}</p>
            </div>            
            <div className="program-details-wrap">
              <p className="program-details-header">Created Date: </p>
              <p className="program-details-value">{modalRecord?.created_at}</p>
            </div>                                    
          </div>
          <div>
              <p className="program-details-header">Comment: </p>
              <p>{<p>{capitalizeFirstLetter(modalRecord?.comments || '')}</p>}</p>
          </div>
        </Box>
      </Modal>
    </>;
};
export default ViewSignature;
